<template>
  <div>
    <el-dialog :visible.sync="visible" width="1200px" class="fee-config-dialog" custom-class="custom-btn" :close-on-click-modal="false" top="0">
      <div class="fee-config">
        <div class="top-box">
          <tooltip v-if="showBtn" class="name1" :txt-info="formData.deptmantName"></tooltip>
          <tooltip v-else class="name1" :txt-info="formData.userName"></tooltip>
          <span class="name2" v-if="formData.commissonTemplateId">
            <span>当前费率模板：</span>
            <tooltip :txt-info="formData.commissonTemplateName"></tooltip>
          </span>
          <span class="name2" v-else>暂未应用费率模板</span>
          <template v-if="showBtn || (!showBtn && formData.type != 1)">
            <el-button class="org-btn" plain v-if="formData.commissonTemplateId" @click="$refs.updateTemplate.open({ ...formData, type: showBtn ? 1 : 2 })"
              >变更费率模板</el-button
            >
            <el-button class="org-btn" plain v-else @click="$refs.updateTemplate.open({ ...formData, type: showBtn ? 1 : 2 }, 'add')"
              >设置费率模板</el-button
            ></template
          >
          <div class="right-box" v-if="formData.commissonTemplateId">
            <el-tooltip placement="top">
              <div slot="content" style="text-align: justify; width: 310px">
                调整规则：按照原费率在一级机构费率中的占比进行调整<br />（如：一级为80%，下级为40%，即下级占一级费率的50%，当一级下调到30%时，系统将自动根据原服务费占比进行下调，即下级调整至15%）
              </div>
              <div class="info-btn" :class="{ noLeftBorder: !showBtn }">
                <i class="iconfont icon-wenhao1"></i>
                <span>费率调整说明</span>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="content">
          <topSearchForm @search="searchAjax()" :hiddenExport="true" :showSwtich="false">
            <el-form :inline="true">
              <el-form-item label="产品名称">
                <el-input v-model="searchParams.productName" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="保险公司">
                <el-select clearable filterable v-model="searchParams.companyCode" placeholder="请选择">
                  <el-option v-for="(bean, i) in companyList" :key="i" :label="bean.name" :value="bean.code"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产品销售属性">
                <el-select clearable v-model="searchParams.sellType" placeholder="请选择">
                  <el-option v-for="(bean, i) in sellTypeMap" :key="i" :label="bean" :value="i"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="险种分类">
                <el-select clearable v-model="searchParams.themeId" placeholder="请选择">
                  <el-option v-for="(bean, i) in typeList" :key="i" :label="bean.name" :value="bean.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上架状态">
                <el-radio-group v-model="searchParams.productStatus" @change="searchAjax()">
                  <el-radio label="">全部</el-radio>
                  <el-radio label="2">已上架</el-radio>
                  <el-radio label="1">已下架</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="产品类型" prop="needProductAgreement">
                <el-select v-model="searchParams.needProductAgreement" placeholder="请选择" clearable>
                  <el-option label="正常产品" value="0"></el-option>
                  <el-option label="协议产品" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </topSearchForm>

          <div v-if="showBtn" class="tabs-box">
            <div class="tabs-item" :class="{ active: activeName == 'all' }" @click="tabClick('all')">全部({{ allCount }})</div>
            <div class="tabs-item" :class="{ active: activeName == '1' }" @click="tabClick('1')">有费率({{ hasCount }})</div>
            <div class="tabs-item" :class="{ active: activeName == '0' }" @click="tabClick('0')">
              无费率({{ noCount }})
              <el-tooltip effect="dark" content="无费率指的是费率为0的产品" placement="top">
                <i class="iconfont icon-wenhao1"></i>
              </el-tooltip>
            </div>
          </div>
          <div v-if="showBtn" class="tools-box">
            <div class="left-box">
              <el-checkbox v-model="isAll" @change="selectClick()">全部产品</el-checkbox>
            </div>
            <div class="right-box">
              <span class="text"
                >已选择<span>{{ selectArr.length }}</span
                >项,共<span>{{ total }}</span
                >款产品</span
              >
              <el-button class="org-btn small" plain @click="del(selectArr, true)">批量删除</el-button>
              <el-button class="org-btn small" @click="$refs.addProduct.open(formData.deptId)">新增产品</el-button>
            </div>
          </div>
          <el-table
            ref="tableRef"
            border
            :data="tableData"
            style="width: 100%"
            class="list-table"
            tooltip-effect="dark"
            v-loading="listLoading"
            :max-height="tableH"
            @select="selectTable"
            @select-all="selectTable"
          >
            <el-table-column v-if="showBtn" type="selection" width="55"></el-table-column>
            <el-table-column property="productName" min-width="230" label="产品名称">
              <div slot-scope="scope">
                <span class="title">{{ scope.row.name }} </span>
                <div class="gray tag" v-if="scope.row.status == 1">已下架</div>
              </div>
            </el-table-column>
            <el-table-column prop="needProductAgreement" label="产品类型" min-width="100">
              <template slot-scope="scope">
                <div class="tag2 blue" v-if="scope.row.needProductAgreement == 1">协议产品</div>
                <div class="tag2 green" v-else>正常产品</div>
              </template>
            </el-table-column>
            <el-table-column property="lowPrice" label="保费" width="150">
              <div slot-scope="scope">{{ scope.row.lowPrice }}元起</div>
            </el-table-column>
            <el-table-column property="remark" label="服务费" width="350">
              <div slot-scope="scope">
                <div class="fee-box">
                  <span v-if="scope.row.minCommissonVal == scope.row.maxCommissonVal">{{ scope.row.minCommissonVal || 0 }}%</span>
                  <span v-else>{{ scope.row.minCommissonVal || 0 }}%~{{ scope.row.maxCommissonVal || 0 }}%</span>
                  <div class="huo-fee-box" v-if="scope.row.maxSubsidyCommissionVal">
                    <i class="huo">活</i> 最高奖励+{{ scope.row.maxSubsidyCommissionVal }}%
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button-group class="line-btn-box">
                  <!-- 此处把团队名字当模板名字传入显示 -->
                  <el-button
                    type="text"
                    size="small"
                    @click="
                      $refs.productFee.open({
                        productId: scope.row.id,
                        productName: scope.row.name,
                        status: scope.row.status,
                        templateId: formData.commissonTemplateId,
                        templateName: showBtn ? formData.deptmantName : formData.userName,
                        subMechanId: formData.deptId,
                        userId: showBtn ? null : formData.userId,
                        type: showBtn ? 1 : 2
                      })
                    "
                    :disabled="scope.row.productCategory != '3'"
                    >查看费率表</el-button
                  >
                  <el-button v-if="showBtn" type="text" size="small" class="red" @click="del([scope.row.id])">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="page"
            background
            :current-page.sync="pageNum"
            :page-size.sync="pageSize"
            :layout="$tools.pageLayout"
            :total="total"
            @size-change="
              isClear = false;
              pageNum = 1;
              pageSize = $event;
              getList();
            "
            @current-change="
              isClear = false;
              getList();
            "
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 新增产品 -->
    <addProduct ref="addProduct" @reload="searchAjax()"></addProduct>
    <!-- 更新模板 -->
    <updateTemplate ref="updateTemplate" @reload="updateTemplateData"></updateTemplate>
    <!-- 产品费率弹窗 -->
    <productFee ref="productFee" @reload="searchAjax()"></productFee>
  </div>
</template>
<script>
import topSearchForm from '@/components/topSearchForm';
import updateTemplate from './updateTemplate';
import addProduct from './addProduct';
import productFee from '../feeTemplate/productFee';
import tooltip from '@/components/tooltip';
import { pageTool } from '@/api/mixins';
export default {
  mixins: [pageTool],
  components: {
    addProduct,
    updateTemplate,
    productFee,
    tooltip,
    topSearchForm
  },
  props: {
    showBtn: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    level: '',
    visible: false,
    loadingObj: {},
    activeName: 'all',
    loading: true,
    tableData: [],
    searchParams: {
      productStatus: '2'
    },
    allCount: 0, //所有的数量
    hasCount: 0, //有费率的数量
    noCount: 0, //无费率的数量
    isAll: false, //全部产品
    isClear: true, //是否清除选择
    selectArr: [], //表格选择的数据
    allIds: [], //所有的产品id
    companyList: [], //保司列表
    typeList: [], //分类列表
    formData: {}, //传入的数据
    sellTypeMap: {
      '1': '网销产品',
      '3': '经代产品'
    },
    tableH: document.body.clientHeight - 400
  }),
  mounted() {
    var userinfo = this.$tools.getLocal('userinfo');
    this.level = userinfo.level;
  },
  methods: {
    open(data = {}) {
      console.log(data);
      this.selectArr = [];
      this.searchParams = { productStatus: '2' };
      this.isAll = false;
      this.isNoTemplateFee = false;
      this.activeName = 'all';
      this.formData = data;
      this.loadingObj = this.$notice.loading();
      this.initListAjax('/master/commissonTemplate/mechanProduct/list');
      this.getTypeList();
      this.getCompanyList();
    },
    // 更换模板后回调
    updateTemplateData(templateData) {
      this.formData.commissonTemplateId = templateData.id;
      this.formData.commissonTemplateName = templateData.name;
      this.searchAjax();
      if (this.showBtn) {
        this.$bus.$emit('refreshTree');
      } else {
        this.$emit('reloadUser');
      }
    },
    // 单个删除
    del(ids, isBatch) {
      if (ids.length == 0) {
        this.$message.error('未选择任何产品');
        return;
      }
      this.$confirm('确定删除产品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: '/master/level2/product/delete',
          type: 'post',
          params: {
            mechanId: this.formData.deptId,
            productIds: ids
          }
        }).then(res => {
          this.$message.success('删除成功');
          this.searchAjax();
          if (isBatch) {
            this.selectArr = [];
          }
        });
      });
    },
    // tab点击
    tabClick(type) {
      this.activeName = type;
      this.searchAjax();
    },
    // 全选点击
    selectClick(isAll) {
      this.tableData.forEach(item => {
        if (this.isAll) {
          this.selectArr = this.allIds;
          this.$refs.tableRef.toggleRowSelection(item, true);
        } else {
          this.selectArr = [];
          this.$refs.tableRef.toggleRowSelection(item, false);
        }
      });
    },
    // 获取产品分类列表
    getTypeList() {
      this.$http({
        url: '/master/product/queryProductThemes',
        type: 'put',
        params: { status: '2' }
      }).then(res => {
        this.typeList = res.data;
      });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: '/master/product/queryAllCompany',
        type: 'put',
        params: {}
      }).then(res => {
        this.companyList = res.data;
      });
    },
    // 表格选择
    selectTable(selection) {
      const selectionIdArr = selection.map(item => {
        return item.id;
      });
      const delIdArr = this.tableData
        .filter(item => {
          return !selectionIdArr.includes(item.id);
        })
        .map(item => {
          return item.id;
        });
      selectionIdArr.forEach(id => {
        if (!this.selectArr.includes(id)) {
          this.selectArr.push(id);
        }
      });
      delIdArr.forEach(id => {
        const i = this.selectArr.indexOf(id);
        if (i != -1) {
          this.selectArr.splice(i, 1);
        }
      });
    },
    setListParams(params) {
      params.templateId = this.formData.commissonTemplateId;
      if (this.showBtn || this.formData.type == 1) {
        //查询机构 || 查询管理员
        params.subMechanId = this.formData.deptId;
      } else {
        params.userId = this.formData.userId;
      }
      if (this.activeName == 'all') {
        params.isCollocateCommisson = '';
      } else {
        params.isCollocateCommisson = this.activeName;
      }
    },
    listCallback(res) {
      this.visible = true;
      this.hasCount = res.isCollocateCount;
      this.noCount = res.isNotCollocateCount;
      this.allCount = this.hasCount + this.noCount;
      this.allIds = res.productIds;
      if (this.isClear) {
        this.selectArr = [];
        this.isAll = false;
      } else {
        this.isClear = true;
      }
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          if (this.selectArr.includes(item.id)) {
            console.log(item);
            this.$refs.tableRef.toggleRowSelection(item, true);
          }
        });
      });
    },
    finallyCallback() {
      this.loadingObj.close && this.loadingObj.close();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './feeConfig.scss';
</style>
